import { createModel } from "@/util/ModelUtil";

export default class UserSubscribeModel {
  constructor(
    public period: number = -1,
    public type: string = "",
    public status: string = "",
    public expiredDate: number = new Date().getTime()
  ) {}

  public static create(list?: UserSubscribe[]): UserSubscribeModel {
    return createModel<UserSubscribeModel>(
      UserSubscribeModel,
      list ? list[0] : list
    );
  }
}
